
export default function Footer() {
  return (
    <footer id="contact" className="bg-gradient-to-br from-sky-700 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/09b42268e64b75a1bdbfb319cdd0d3b1/d006109a30e331b05fb01253f30422e1.png"
              alt="The Way at the Lake"
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-white/90 leading-relaxed">
              Experience the natural beauty and tranquility of The Way at the Lake. Your perfect escape into nature awaits.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#wildlife" className="text-sm text-white/90 hover:text-white transition-colors cursor-pointer">
                  Wildlife
                </a>
              </li>
              <li>
                <a href="#activities" className="text-sm text-white/90 hover:text-white transition-colors cursor-pointer">
                  Activities
                </a>
              </li>
              <li>
                <a href="#visitor-info" className="text-sm text-white/90 hover:text-white transition-colors cursor-pointer">
                  Visitor Information
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-white/90 hover:text-white transition-colors cursor-pointer">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contact Details</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-phone-line text-lg mr-2 mt-0.5"></i>
                <div>
                  <p className="text-sm text-white/90">(555) 123-4567</p>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-lg mr-2 mt-0.5"></i>
                <div>
                  <p className="text-sm text-white/90">info@thewaylake.com</p>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line text-lg mr-2 mt-0.5"></i>
                <div>
                  <p className="text-sm text-white/90">1234 Lakeshore Drive<br />Mountain View, CO 80401</p>
                </div>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Follow Us</h4>
            <div className="flex gap-3 mb-6">
              <a
                href="#"
                className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer"
              >
                <i className="ri-youtube-line text-lg"></i>
              </a>
            </div>
            <p className="text-sm text-white/90">
              Stay updated with the latest news, events, and special offers.
            </p>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/80">
              © 2025 The Way at the Lake. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                Terms of Service
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
